import styled, { css } from 'styled-components';

export const hiddenCss = css`
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
`;

/**
 * A hidden element which is still readable by screen-readers and bots.
 *
 * Used to maintain accessibility and correct document outline.
 * Use the as="h1" prop to ensure the right element is used.
 */
export const Hidden = styled.span`
    ${hiddenCss};
`;
